import { inject, type Signal } from "@angular/core";
import { Router, type CanActivateFn } from "@angular/router";
import { AuthService } from "../services/auth.service";

/**
 * Auth guard that checks authentication status.
 * Runs after APP_INITIALIZER completes session check.
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isAuthenticatedSignal: Signal<boolean> = authService.isAuthenticated();
  const isAuthenticated = isAuthenticatedSignal();

  if (isAuthenticated) {
    return true;
  }

  // Redirect to login if not authenticated
  void router.navigate(["/login"], {
    queryParams: { reason: "unauthenticated" },
  });
  return false;
};
